import React from 'react';
import PropTypes from 'prop-types';

import IconCheck from 'components/icons/iconCheck';
import SanitizedHtml from 'components/consumer/SanitizedHtml';

const ProtectionPlanListItem = ({ desc }) => {
  // removing strong from 'Everything in the life happens plan';
  const descCleaned = desc.replace('<strong>', '').replace('</strong>', '');

  return (
    <li className="text-base flex pb-[.15rem] list-none">
      <IconCheck width="16" height="16" className="pr-[.2rem] mt-1 mr-2" />
      <SanitizedHtml className="text-left" html={descCleaned} />
    </li>
  );
};

ProtectionPlanListItem.propTypes = {
  desc: PropTypes.string,
};

export default ProtectionPlanListItem;
